export function getChangedLanguage(selectedLanguage: string): string {
  return selectedLanguage === 'en' ? 'id' : 'en';
}

export function test(): void {}
